import { createFileRoute } from '@tanstack/react-router'
import { PermissionRouteGuard } from '@/hooks/usePermissions'
import { AffiliationDetailPage } from '@/pages/AffiliationDetail'

export const Route = createFileRoute('/_authenticated/affiliations_/$affiliationId')({
  component: AffiliationDetailRoute,
})

function AffiliationDetailRoute() {
  const { affiliationId } = Route.useParams()
  return (
    <PermissionRouteGuard resource="affiliations" action="read">
      <AffiliationDetailPage affiliationId={affiliationId} />
    </PermissionRouteGuard>
  )
}
